import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useLocaleToggle() {
  const { i18n } = useTranslation();

  const toggleLocale = useCallback(() => {
    i18n.changeLanguage(i18n.language === "en" ? "hr" : "en");
  }, [i18n]);

  const otherLocaleName = useMemo(
    () => (i18n.language === "en" ? "Hrvatski" : "English"),
    [i18n.language],
  );

  const localeCodeUpper = useMemo(
    () => i18n.language.toUpperCase(),
    [i18n.language],
  );

  return { toggleLocale, otherLocaleName, localeCodeUpper };
}
